import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Frequency } from '../../../manageMentorship/types/frequency';
import { WeekdayPosition } from '../../../manageMentorship/types/weekdayPosition';
import { useGetWeekdayPositionInMonth } from '../hooks/useGetWeekdayPositionInMonth';
import { DateHelper } from 'src/shared/helpers/date';
export function useFrequencyItems() {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    const date = watch('date');
    const weekday = DateHelper.formatIsoString(date.toISOString(), { weekday: 'long' });
    const { position, isTheLastDay } = useGetWeekdayPositionInMonth(date);
    const frequencyItems = useMemo(() => [
        {
            label: t('mentorship.form.recurring_session.frequency.options.daily'),
            value: Frequency.Daily
        },
        {
            label: t('mentorship.form.recurring_session.frequency.options.weekly', {
                weekday
            }),
            value: Frequency.WeeklyOnDay
        },
        ...(position.key !== WeekdayPosition.Fifth
            ? [
                {
                    label: t('mentorship.form.recurring_session.frequency.options.monthly', {
                        day_position_in_month: position.text,
                        weekday
                    }),
                    value: position.key
                }
            ]
            : []),
        ...(isTheLastDay
            ? [
                {
                    label: t('mentorship.form.recurring_session.frequency.options.monthly', {
                        day_position_in_month: t('mentorship.day_position_in_month.last'),
                        weekday
                    }),
                    value: Frequency.MonthlyOnLastWeekday
                }
            ]
            : []),
        {
            label: t('mentorship.form.recurring_session.frequency.options.every_weekday'),
            value: Frequency.Weekday
        },
        {
            label: t('mentorship.form.recurring_session.frequency.options.custom.label'),
            value: Frequency.Custom
        }
    ], [t, weekday, position.key, position.text, isTheLastDay]);
    return frequencyItems;
}
